import Events from 'events'

export const REAUTH_REQUIRED_EVENT = 'app:reauth-required'

const reAuthEvents = new Events.EventEmitter()

export const emitReauthRequired = () => {
  reAuthEvents.emit(REAUTH_REQUIRED_EVENT)
}

export default reAuthEvents
